import React, { useContext, useState, useEffect } from "react";
import { AppContext } from "../AppProvider";
import PageLayout from "../PageLayout";

import { apiRequest } from "../utils/Axios";

const Login = () => {
    const { auth, userData, setAuth, setUserData } = useContext(AppContext);

    // State untuk loading, pesan error, username, dan password
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [username, setUsername] = useState("222310001");
    const [password, setPassword] = useState("83658*");
    const [showPassword, setShowPassword] = useState(false);

    // Fungsi untuk menangani submit login
    const handleSubmit = async (e) => {
        e.preventDefault(); // Mencegah reload halaman

        // Validasi input: memastikan username tidak kosong
        if (username.trim() === '') {
            setError('Username diperlukan');
            return;
        }

        // Validasi input: memastikan password tidak kosong
        if (password.trim() === '') {
            setError('Password diperlukan');
            return;
        }

        setIsLoading(true); // Mengatur loading menjadi true saat permintaan dimulai
        
        // Melakukan request login
        const fetchData = async () => {
            const result = await apiRequest('POST', '/auth/login', {
                username, password
            });

            if (result.code === 'ok') {
                const { token, user } = result;
                
                setAuth(token);
                setUserData(user);
            }else{
                setError((result.msg || 'Kesalahan terjadi!'));
            }
        }
        await fetchData();

        setIsLoading(false); // Mengatur loading kembali ke false setelah permintaan selesai
    };

    // Fungsi untuk mereset input username dan password
    const handleReset = () => {
        setUsername(''); 
        setPassword('');
    };

    // Fungsi untuk mereset input username dan password
    const handleShowPassword = (checked) => {
        setShowPassword(checked)
    };

    return (
        <PageLayout>
            <section className="pb-4">
                <div className="px-4 grid gap-4">
                    <h2 className="text-xl font-semibold">Masuk Siswa</h2>
                    <p>Masukkan NIS dan Password masing-masing!</p>
                    {error && <p className="text-red-500 mt-2">{error}</p>}
                    <form className="grid gap-3" onSubmit={handleSubmit}>
                        {/* Input untuk Username / NIS */}
                        <label className="input input-bordered flex items-center gap-4">
                            <i className="bi bi-person-circle text-xl"></i>
                            <input
                                type="text" 
                                value={username} 
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Username / NIS"
                                required
                            />
                        </label>
                        <label className="relative input input-bordered flex items-center gap-4">
                            <i className="bi bi-key-fill text-xl"></i>
                            <input
                                type={showPassword ? 'text' : 'password'} 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Kata Sandi"
                                required
                            />
                            <label className="swap swap-flip text-xl absolute right-3">
                                <input type="checkbox" onChange={(e) => handleShowPassword(e.target.checked)} checked={showPassword} />
                                <div className="swap-on">🐵</div>
                                <div className="swap-off">🙈</div>
                            </label>
                        </label>
                        <div className="grid grid-cols-2 gap-4">
                            {/* Tombol submit untuk login */}
                            <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                {isLoading ? "Loading.." : "Masuk"}
                            </button>
                            {/* Tombol untuk mereset input */}
                            <button type="button" className="btn btn-secondary" onClick={handleReset}>Ulang</button>
                        </div>
                    </form>
                </div>
            </section>
        </PageLayout>
    );
}

export default Login;
